import { Box, Button, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { CreatePatientForm } from "types";

interface ImageUploadProps {
  name: keyof CreatePatientForm;
}

function ImageUpload({ name }: ImageUploadProps) {
  const { control } = useFormContext<CreatePatientForm>();
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    onChange: (file: File | null) => void
  ) => {
    const file = event.target.files?.[0] || null;

    if (file) {
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange } }) => (
        <Box className="flex items-center gap-4">
          <Box className="size-20 rounded-full bg-gray-100 flex items-center justify-center overflow-hidden">
            {previewUrl ? (
              <img
                src={previewUrl}
                alt="Patient profile"
                className="w-full h-full object-cover"
              />
            ) : (
              <Typography className="text-gray-400 text-4xl">👤</Typography>
            )}
          </Box>

          <Button
            variant="outlined"
            onClick={handleClick}
            className="px-6 py-2 rounded-full"
          >
            Upload Image
          </Button>

          <input
            ref={fileInputRef}
            type="file"
            accept="image/*"
            style={{ display: "none" }}
            onChange={(e) => handleFileChange(e, onChange)}
          />
        </Box>
      )}
    />
  );
}

export default ImageUpload;
